<template>
  <div>
    <!-- <b-button @click="saveData(itemList)">Guardar</b-button> -->
    <FormLeyes
      v-for="(item, index) in listaLeyesTramite"
      :key="index"
      :removeItem="removeItem"
      :objTest="item"
      :index="index"
      :readOnly="readOnly"
    />

    <div v-if="!readOnly" class="add-btn" @click="addItemList" v-b-tooltip.hover title="Agregar otro Boletín">
      <hr class="separator-hr" />
      <b-button class="button-leyes"><i class="bx bx-plus"></i></b-button>
      <hr class="separator-hr" />
    </div>
  </div>
</template>
<script>
import FormLeyes from "./FormLeyes.vue";

export default {
  components: {
    FormLeyes,
  },
  data() {
    return {
      anio: process.env.VUE_APP_ANIO,
    };
  },
  props: ["listaLeyesTramite", "addItemList", "removeItem", "readOnly"],
  mounted() {
    this.addItemList();
  },
};
</script>
<style scoped>
.add-btn {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  cursor: pointer;
}
.separator-hr {
  width: 45%;
}
.button-leyes {
  font-size: 20px;
  height: 20px;
  width: 20px;
  border-radius: 20px;
  border: 2px solid #ccc;
  background: white;
  padding: 0;
  color: #ccc;
}
.bx-plus {
  position: relative;
  left: -2px;
  top: -5px;
}
.btn-check:focus + .btn,
.btn-secondary:hover,
.btn:focus {
  box-shadow: none;
  color: #ccc;
  border: 2px solid #ccc;
  background: white;
}
</style>
